// Configuración del backend por negocio, leída EN TIEMPO DE EJECUCIÓN desde /config.js
// (lo sirve Caddy con la URL y la llave pública del negocio). Así un solo build sirve a todos los negocios.
declare global {
  interface Window {
    __CRM_CONFIG__?: { url: string; key: string; slug?: string; name?: string };
  }
}

export const getBackendUrl = (): string =>
  (typeof window !== "undefined" && window.__CRM_CONFIG__?.url) ||
  import.meta.env.VITE_SUPABASE_URL;

export const getBackendKey = (): string =>
  (typeof window !== "undefined" && window.__CRM_CONFIG__?.key) ||
  import.meta.env.VITE_SB_PUBLISHABLE_KEY;

// Sesión separada por negocio: varios negocios pueden vivir bajo el mismo dominio (/demo1/, /demo2/…).
export const getClientOptions = () => {
  const slug = typeof window !== "undefined" ? window.__CRM_CONFIG__?.slug : undefined;
  return slug ? { auth: { storageKey: `sb-crm-${slug}-auth` } } : undefined;
};
